import InitConfirm from "./InitConfirm";
import {useContext} from "react";
import {CompanyApprovalContext} from "../../tools/contexts/companyApproval/CompanyApprovalContext";
import LoadingScreen from "../LoadingScreen";
import PLATFORMS from "../../tools/defaults/Platforms";
import CreatePayment from "./CreatePayment";
import CompanyBusinessInquiry from "./CompanyBusinessInquiry";
import Final from "./Final";
import Widget from "./Widget";

const CompanyApprovalContent = () => {
    const companyApprovalContext = useContext(CompanyApprovalContext);

    if (companyApprovalContext.isLoading) {
        return <LoadingScreen text={companyApprovalContext.loadingMessage || 'لطفا منتظر بمانید'}/>
    }
    if(companyApprovalContext.widget){
        return  <Widget/>
    }
    if (companyApprovalContext.isReported) {
        return <Final title={companyApprovalContext.reportedTitle || 'موفق'}
                      message={companyApprovalContext.reportedMessage}/>
    }
    return <div>
        {companyApprovalContext?.components?.current_component?.name === PLATFORMS.DIVAR.APPS.COMPANY_APPROVAL.STEPS.INIT_CONFIRM &&
            <InitConfirm/>}
        {companyApprovalContext?.components?.current_component?.name === PLATFORMS.DIVAR.APPS.COMPANY_APPROVAL.STEPS.CREATE_PAYMENT &&
            <CreatePayment/>}
        {companyApprovalContext?.components?.current_component?.name === PLATFORMS.DIVAR.APPS.COMPANY_APPROVAL.STEPS.PAYMENT_INQUIRY &&
            <CreatePayment/>}
        {companyApprovalContext?.components?.current_component?.name === PLATFORMS.DIVAR.APPS.COMPANY_APPROVAL.STEPS.COMPANY_BUSINESS_LICENSE_INQUIRY &&
            <CompanyBusinessInquiry/>}
        {companyApprovalContext.components?.current_component?.name === PLATFORMS.DIVAR.APPS.COMPANY_APPROVAL.STEPS.FINAL &&
            <Final title={'موفق'} message={'افزونه با موفقیت بر روی آگهی شما اضافه شده است.'}/>}

    </div>
}
export default CompanyApprovalContent;